import type { SVGProps } from 'react';
const SvgHomepageHeader1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={104} height={100} fill="none" {...props}>
    <path
      fill="#fff"
      fillOpacity={0.4}
      d="M48.207 15.846 47.61.72 17.313 1.985l.596 15.128-17.314.724L2.467 65.38l64.924-2.715-1.871-47.544zM26.31 10.268l12.985-.543.255 6.483-12.985.543zm32.084 44.116-47.61 1.99L9.591 26.12l47.611-1.99z"
    />
    <path
      fill="#fff"
      fillOpacity={0.4}
      d="m44.649 35.483.34 8.645-6.492.27.255 6.484-8.657.362-.255-6.483-6.492.271-.34-8.644 6.492-.272-.256-6.483 8.657-.362.255 6.483zM98.435 47.53l.436-4.486-8.974-.9-.435 4.487-5.128-.514-1.369 14.099 19.229 1.926 1.369-14.099zm-6.223-2.565 3.846.385-.187 1.923-3.845-.386zm7.667 14.357-14.101-1.413.871-8.972 14.101 1.413z"
    />
    <path
      fill="#fff"
      fillOpacity={0.4}
      d="m96.594 53.168-.249 2.564-1.923-.193-.186 1.923-2.564-.257.186-1.923-1.922-.192.248-2.564 1.923.193.187-1.923 2.564.257-.187 1.923zM47.627 82.59l-1.149-4.355-8.71 2.371 1.149 4.354-4.977 1.355L37.55 100l18.663-5.08-3.61-13.685zm-6.714-.173 3.733-1.016.492 1.866-3.733 1.016zm12.156 10.692-13.687 3.725-2.298-8.708L50.772 84.4z"
    />
    <path
      fill="#fff"
      fillOpacity={0.4}
      d="m47.86 88.528.656 2.488-1.866.508.492 1.866-2.488.678-.493-1.866-1.866.508-.656-2.488 1.866-.508-.492-1.867 2.489-.677.492 1.866z"
    />
  </svg>
);
export default SvgHomepageHeader1;
